export enum UserUnitRole {
  RESIDENT = 'resident',
  TENANT = 'tenant',
}

export enum UserGlobalRole {
  CUSTOMER = 'customer',
  PROSPECT = 'prospect',
}
